import React from 'react'
import styles from './notFound.css'

const NotFound = () => {
  return (
    <div className={styles.container}>
      <h1>404</h1>
      <h3>Das Dokument wurde nicht gefunden</h3>
    </div>
  )
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/notFound/notFound.jsx